import { AbstractControlOptions } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        physicalOwnerIds: [entity?.physicalOwnerIds || null],
        productIds: [entity?.productIds || null],
        companyOwnerIds: [entity?.companyOwnerIds || null],
      },
      options,
    );
  }

  extract() {
    return this.form.value;
  }
}
